var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { TvShopStateService } from '../../../services/state/tv-shop-state.service';
import { Order } from '../../../model/order';
import { OrderingModalManagerComponent } from '../../../modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import { NavigableComponent } from '../../../model/navigable-component';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { PageNames } from '../../../shared/page-names.enum';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { Router } from '@angular/router';
import { OmapiIdsUtils } from '../../../shared/utils/omapi-ids/omapi-ids-utils';
import { DtvCatalogUtils } from '../../../utils/dtv-catalog/dtv-catalog.utils';
var StandaloneFlavorsComponent = /** @class */ (function (_super) {
    __extends(StandaloneFlavorsComponent, _super);
    function StandaloneFlavorsComponent(navigationService, changeDetector, analyticsService, stateService, router) {
        var _this = _super.call(this, navigationService) || this;
        _this.navigationService = navigationService;
        _this.changeDetector = changeDetector;
        _this.analyticsService = analyticsService;
        _this.stateService = stateService;
        _this.router = router;
        _this.standaloneOptions = [{
                name: 'basic',
                omapiId: OmapiIdsUtils.NETFLIX_BASIC_ID,
                descriptionKey: 'eos-tv-shop-ii.text.netflix-basic-flavor',
                titleKey: 'eos-tv-shop-ii.title.netflix-basic-flavor',
                pack: null,
                priceDetail: null
            }, {
                name: 'standard',
                omapiId: OmapiIdsUtils.NETFLIX_STANDARD_ID,
                descriptionKey: 'eos-tv-shop-ii.text.netflix-standard-flavor',
                titleKey: 'eos-tv-shop-ii.title.netflix-standard-flavor',
                pack: null,
                priceDetail: null
            }, {
                name: 'premium',
                omapiId: OmapiIdsUtils.NETFLIX_PREMIUM_ID,
                descriptionKey: 'eos-tv-shop-ii.text.netflix-premium-flavor',
                titleKey: 'eos-tv-shop-ii.title.netflix-premium-flavor',
                pack: null,
                priceDetail: null
            }
        ];
        _this.componentName = PageNames.STANDALONE_FLAVORS;
        _this.streamingServices = _this.stateService.selectSnapshot(function (state) { return state.tvShopStreamingServices; });
        _this.selectedTvShopEntertainmentPack = stateService.selectSnapshot(function (state) { return state.basket.selectedTvShopEntertainmentPack; });
        _this.omapiId = _this.selectedTvShopEntertainmentPack.omapiId;
        _this.enrichOptions();
        _this.order = new Order(_this.selectedTvShopEntertainmentPack.omapiId, _this.selectedTvShopEntertainmentPack.priceDetail.price.value, null, null);
        return _this;
    }
    StandaloneFlavorsComponent.prototype.ngOnInit = function () {
        this.navigationService.setCurrentPageComponent(PageNames.STANDALONE_FLAVORS);
        this.analyticsService.onDetailPage([this.selectedTvShopEntertainmentPack.omapiId]);
    };
    StandaloneFlavorsComponent.prototype.ngAfterViewInit = function () {
        this.changeDetector.detectChanges();
        this.navigationService.registerPageElement(this.standaloneFlavors);
        this.navigationService.resetNavigation();
    };
    StandaloneFlavorsComponent.prototype.ngOnDestroy = function () {
        this.navigationService.clearNavigation();
    };
    StandaloneFlavorsComponent.prototype.enrichOptions = function () {
        var _this = this;
        this.standaloneOptions.forEach(function (option) {
            option.pack = DtvCatalogUtils.getStreamingServicesOptionForOmapiId(_this.streamingServices, option.omapiId);
            option.priceDetail = DtvCatalogUtils.getPriceForProduct(_this.streamingServices, option.omapiId);
        });
    };
    StandaloneFlavorsComponent.prototype.onEmitOrderProduct = function (order) {
        this.order = order;
        this.stateService.setTvShopEntertainmentPack(DtvCatalogUtils.getStreamingServicesOptionForOmapiId(this.streamingServices, order.packOmapiId));
        this.orderingModal.openModal();
    };
    StandaloneFlavorsComponent.prototype.onBack = function () {
        this.navigationService.resetNavigation();
        this.navigationService.clearNavigation();
        this.routeOnBackPressed();
    };
    StandaloneFlavorsComponent.prototype.routeOnBackPressed = function () {
        this.router.navigate(['/product-details/' + this.omapiId], { queryParamsHandling: 'merge' });
    };
    return StandaloneFlavorsComponent;
}(NavigableComponent));
export { StandaloneFlavorsComponent };
